import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { isError } from "utils/api/models/api-response";
import { AddContactAsync } from "services/contacts";

export default function AddContact() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(AddContactAsync, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          queryClient.invalidateQueries("Contacts");
        }
      },
    }),
  };
}
